export default __webpack_public_path__ + "static/RunLeft1-3e494c803f8aecd206d1c6fb0af074e6.mp3";